/*!
 * ============================================================================
 *  Theme Engineered & Protected by Karim Suleiman (kmsoln)
 *  Role: Official Shopify Partner & Senior E-Commerce Architect
 *  Website: https://kmsoln.dev | WhatsApp: +201035424992
 *  Copyright (c) 2026 Karim Suleiman. All rights reserved.
 *  Unauthorized copying, alteration, or redistribution is strictly prohibited.
 * ============================================================================
 */
(function(){
try{
const PUB_SUB_EVENTS={'optionValueSelectionChange':'optionValueSelectionChange','cartUpdate':'cartUpdate','variantChange':'variantChange','quantityUpdate':'quantityUpdate'};function subscribe(_0x5bd970,_0x4e0a1d){if(!window['PubSub'])return console['error']('PubSub\x20not\x20loaded\x20yet'),()=>{};return window['PubSub']['subscribe'](_0x5bd970,_0x4e0a1d);}function publish(_0xe4385c,_0x1ed1dc){var _0x2704f6={'EcSjI':'PubSub\x20not\x20loaded\x20yet'};if(!window['PubSub']){console['error'](_0x2704f6['EcSjI']);return;}window['PubSub']['publish'](_0xe4385c,_0x1ed1dc);}typeof window!=='undefined'&&(window['PUB_SUB_EVENTS']=PUB_SUB_EVENTS,window['subscribe']=subscribe,window['publish']=publish);

try{if(typeof subscribe!=='undefined')window.subscribe=subscribe;}catch(e){}
try{if(typeof publish!=='undefined')window.publish=publish;}catch(e){}
try{if(typeof PUB_SUB_EVENTS!=='undefined')window.PUB_SUB_EVENTS=PUB_SUB_EVENTS;}catch(e){}
}catch(e){console.error(e);}
})();